import { render, staticRenderFns } from "./DiagnosticMeasurements.vue?vue&type=template&id=5a346388&scoped=true&lang=pug"
import script from "./DiagnosticMeasurements.vue?vue&type=script&lang=js"
export * from "./DiagnosticMeasurements.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticMeasurements.vue?vue&type=style&index=0&id=5a346388&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a346388",
  null
  
)

export default component.exports